import axiosInstance, { ApiKeys, getApiUrl } from '@cp/src/utils/ApiHelper';
import { getFileDownload } from '@cp/src/utils/commonUtils';
import { UploadFileResponse } from './types';
import { AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';
import { API_STATUS_CODE } from '@cp/src/utils/ApiHelperUtils';

export const downloadSampleFile = (type: string) => {
  const url = getApiUrl(ApiKeys.GET_ALLOCATION_ORIGINAL_FILE, { type: type });

  return (dispatch: Dispatch<any>) => {
    axiosInstance.get(url).then(response => {
      if (response?.data) {
        const fileUrl = response?.data?.data;
        getFileDownload(fileUrl);
      }
    });
  };
};

export const uploadAllocationFile = async (
  file: File | null,
  agencyCode: string,
  type: string
): Promise<UploadFileResponse | null> => {
  if (!file) {
    return Promise.reject('No file provided for upload.');
  }
  const url = getApiUrl(ApiKeys.UPLOAD_CASES_ALLOCATE_DEALLOCATE, {
    agencyCode: agencyCode,
    type: type
  });
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await axiosInstance.put(url, formData, {
      headers: { donotHandleError: true, includeInUptimeMetrics: true }
    });
    if (response.status === API_STATUS_CODE.ACCEPTED) {
      return { success: true, message: '', error: false };
    } else return { error: true, message: response.data.title, success: false };
  } catch (error) {
    if (error instanceof AxiosError) {
      return { error: true, message: error?.response?.data?.title, success: false };
    }
  }
  return null;
};

export const uploadAgencyAllocationFile = async (
  file: File | null,
  type: string
): Promise<UploadFileResponse | null> => {
  if (!file) {
    return Promise.reject('No file provided for upload.');
  }
  const url = getApiUrl(ApiKeys.UPLOAD_AGENCY_CASES_ALLOCATE_DEALLOCATE, {
    type: type
  });
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await axiosInstance.put(url, formData, {
      headers: { donotHandleError: true, includeInUptimeMetrics: true }
    });
    if (response.status === API_STATUS_CODE.ACCEPTED) {
      return { success: true, message: '', error: false };
    } else return { error: true, message: response.data.title, success: false };
  } catch (error) {
    if (error instanceof AxiosError) {
      return { error: true, message: error?.response?.data?.title, success: false };
    }
  }
  return null;
};
